var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    {
      staticClass: "pa-0 pull-up card-option mb-6 mx-auto",
      attrs: { "max-width": this.$vuetify.breakpoint.smAndDown ? 300 : 1000 },
      on: { click: _vm.click }
    },
    [
      _c(
        "v-row",
        { attrs: { "no-gutters": "" } },
        [
          _c(
            "v-avatar",
            { attrs: { height: "150", "min-width": "300", tile: "" } },
            [_c("v-img", { attrs: { src: _vm.image } })],
            1
          ),
          _c(
            "v-col",
            [
              _c("v-card-title", { staticClass: "pb-0" }, [_vm._t("title")], 2),
              _c(
                "v-card-text",
                { staticClass: "text--primary" },
                [_vm._t("content")],
                2
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }